import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function SearchSelect({ options, value, onChange, placeholder = '' }) {
    const { t } = useTranslation();
    const [search, setSearch] = useState('');
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
                setSearch('');
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    const filtered = options.filter(opt =>
        opt.label.toLowerCase().includes(search.toLowerCase())
    );

    const selected = options.find(opt => String(opt.value) === String(value));

    const handleSelect = (opt) => {
        onChange(opt.value);
        setSearch('');
        setOpen(false);
    };

    const handleClear = (e) => {
        e.stopPropagation();
        onChange('');
        setSearch('');
    };

    return (
        <div className="search-select" ref={ref}>
            <div
                className={`search-select-trigger ${open ? 'open' : ''}`}
                onClick={() => setOpen(!open)}
            >
                <span className={selected ? 'selected-label' : 'placeholder-label'}>
                    {selected ? selected.label : (placeholder || t('search.placeholder'))}
                </span>
                <div className="search-select-icons">
                    {selected && (
                        <span className="clear-btn" onClick={handleClear}>✕</span>
                    )}
                    <span className="chevron">{open ? '▲' : '▼'}</span>
                </div>
            </div>

            {open && (
                <div className="search-select-dropdown">
                    <div className="search-select-search">
                        <input
                            type="text"
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            placeholder={t('search.type_to_search')}
                            autoFocus
                            onClick={e => e.stopPropagation()}
                        />
                    </div>
                    <div className="search-select-options">
                        {filtered.length === 0 ? (
                            <div className="search-select-empty">{t('search.no_results')}</div>
                        ) : (
                            filtered.map(opt => (
                                <div
                                    key={opt.value}
                                    className={`search-select-option ${String(opt.value) === String(value) ? 'active' : ''}`}
                                    onClick={() => handleSelect(opt)}
                                >
                                    {opt.label}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default SearchSelect;